import { TableColumn } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { EntityRefLink } from '@backstage/plugin-catalog-react';
import { Box } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import {
  BU_ANNOTATION,
  PU_ANNOTATION,
  annotationValue,
  emailToUserRef,
  stripManagerSuffix,
} from './utils';

export const groupColumns: TableColumn<CatalogTableRow>[] = [
  {
    title: 'Name',
    field: 'resolved.entityRef',
    highlight: true,
    customSort({ entity: e1 }, { entity: e2 }) {
      const t1 = stripManagerSuffix(e1.metadata.title ?? e1.metadata.name);
      const t2 = stripManagerSuffix(e2.metadata.title ?? e2.metadata.name);
      return t1.localeCompare(t2);
    },
    render: ({ entity }) => {
      const displayName = stripManagerSuffix(
        entity.metadata.title ?? entity.metadata.name,
      );
      return (
        <EntityRefLink entityRef={entity} defaultKind="group">
          {displayName}
        </EntityRefLink>
      );
    },
  },
  {
    title: 'Manager',
    field: 'entity.metadata.managers',
    render: ({ entity }) => {
      const managers = (entity.metadata as Record<string, unknown>)
        .managers as { name?: string; email?: string }[] | undefined;
      const manager = managers?.[0];
      if (!manager?.name) return <>—</>;
      const ref = manager.email ? emailToUserRef(manager.email) : null;
      const content = (
        <Box display="flex" alignItems="center">
          <PersonIcon fontSize="small" style={{ marginRight: 8 }} />
          <span>{manager.name}</span>
        </Box>
      );
      return ref ? (
        <EntityRefLink entityRef={ref} defaultKind="user" hideIcon>
          {content}
        </EntityRefLink>
      ) : (
        <>{content}</>
      );
    },
  },
  {
    title: 'Business Unit',
    field: `entity.metadata.annotations.${BU_ANNOTATION}`,
    render: ({ entity }) => annotationValue(entity, BU_ANNOTATION),
  },
  {
    title: 'Product Unit',
    field: `entity.metadata.annotations.${PU_ANNOTATION}`,
    render: ({ entity }) => annotationValue(entity, PU_ANNOTATION),
  },
  {
    title: 'Type',
    field: 'entity.spec.type',
    render: ({ entity }) => {
      const type = entity.spec?.type;
      return typeof type === 'string' ? type : '—';
    },
  },
];
